import dayjs from "dayjs";

// Mobile-only exception to the checklist's usual dd-mm-yyyy render rule
// (docs/new-module-checklist.md Section 8 point 11 / Section 10.4 point 5) -
// scoped to this module's mobile Account Summary / Brands tables only, per
// the source epic's Story 4 ("shortened date format (16 Jul)"). Deliberately
// kept local to the mobile tree rather than added to the shared
// ../formatters.ts, since buildTarget is mobile-only for this pass (see
// docs/module-configs/optifund-dashboard-mobile.jsonc).
export function formatShortDisplayDate(date: string): string {
  return dayjs(date).format("D MMM");
}
